import { jsx } from 'react/jsx-runtime';
import { MultiselectResourceCreators } from '../MutliselectResourceCreators.js';
import { useResourceListPreferencesContext } from '../ResourceList/contexts/resourceListContextPreferences.js';

const ResourceFilterCreator = ({ resourceId }) => {
  const { filters, setFilterUserIds } = useResourceListPreferencesContext();
  return /* @__PURE__ */ jsx(MultiselectResourceCreators, {
    parentResourceId: resourceId,
    value: filters.userIds,
    onChange: setFilterUserIds
  });
};

export { ResourceFilterCreator };
//# sourceMappingURL=ResourceFilterCreator.js.map
